import React from "react";

import "./index.scss";

const TagsIcon = props => (
  <svg id="Tag_List_SVG" data-name="Tags List" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" className="tags-icon">
    <g id="Tag_List" data-name="Tag List" transform="translate(16 16)">
      <g id="Group_8753" data-name="Group 8753" transform="translate(-16 -16)" className={`default ${props.active ? "active" : ""}`}>
        <path id="Path_8585" data-name="Path 8585" className="cls-1" d="M0,0H32V32H0Z" />
        <path
          id="Path_8586"
          data-name="Path 8586"
          className="cls-2"
          d="M8.129,4.5H23.871A1.142,1.142,0,0,1,25,5.654V27.5l-9-3.68L7,27.5V5.654A1.142,1.142,0,0,1,8.129,4.5Z"
        />
        <g id="Group_8752" data-name="Group 8752">
          <rect id="Rectangle_267" data-name="Rectangle 267" className="cls-3" width="1.464" height="3.651" transform="translate(20.068 17)" />
          <rect id="Rectangle_268" data-name="Rectangle 268" className="cls-3" width="1.464" height="8.783" transform="translate(10.468 11.868)" />
          <rect id="Rectangle_269" data-name="Rectangle 269" className="cls-3" width="1.464" height="13.174" transform="translate(15.268 7.477)" />
        </g>
      </g>
    </g>
  </svg>
);

export default TagsIcon;
